export const OPP_STATUS = {
  planned: "مخطط لها",
  open: "مفتوحة",
  done: "منفذة",
  cancelled: "ملغاة",
};

export const OPP_STATUS_COLORS = {
  planned: "bg-blue-500/15 text-blue-700 border-blue-400/40",
  open: "bg-emerald-500/15 text-emerald-700 border-emerald-400/40",
  done: "bg-amber-500/20 text-amber-800 border-amber-500/50",
  cancelled: "bg-red-500/15 text-red-700 border-red-400/40",
};

export const VOL_TYPE = { student: "طالب", staff: "موظف" };
export const OPP_VOL_TYPE = { student: "طلاب", staff: "موظفون", both: "الجميع" };
export const CHALLENGE_METRIC = {
  hours: "إجمالي الساعات",
  volunteers: "عدد المتطوعين",
  activities: "عدد الأنشطة",
  opportunities: "عدد الفرص",
};

export const DEPT_LINE1 = "المسؤولية المجتمعية والعمل التطوعي في";
export const DEPT_LINE2 = "الإدارة العامة للتعليم بمنطقة حائل";
export const DOCTOR = "المسؤولية المجتمعية والعمل التطوعي — الإدارة العامة للتعليم بمنطقة حائل";
export const BRAND = "ملف الإنجاز التطوعي";
export const BRAND_SUB = "ملف إنجاز الأعمال التطوعية في مدارس منطقة حائل";
export const HEADER_TITLE = "ملف الإنجاز التطوعي";

export const PHRASES = [
  "بصمتك في الخير تبقى",
  "التطوع رسالة إنسانية ووطن يزدهر بأبنائه",
  "كل ساعة تطوع أثرٌ في حياة إنسان",
  "معاً نصنع جيلاً يعطي بلا حدود",
  "العطاء عادة الكبار وطريق العظماء",
];
